import { Link as Clink, Image } from '@chakra-ui/react';
import Link from 'next/link';
import React from 'react';

type Props = {
  href: string;
  type: 'ios' | 'android';
  [key: string]: any;
};

const StoreLinkAlt = ({ href, type, ...rest }: Props) => (
  <Link href={href} passHref>
    <Clink
      aria-label={`${type} store download button`}
      display="flex"
      alignItems="center"
      justifyContent="center"
      color="white"
      width={[`150px`, null, `187px`]}
      height={[`40px`, null, `50px`]}
      _hover={{ textDecoration: `none` }}
      me={[type === `android` ? 0 : 2, null, 4]}
      target="_blank"
      rel="nofollow"
      userSelect="none"
      {...rest}
    >
      <Image
        alt={`${type} store download button`}
        src={`/images/landing/${type}-button.png`}
        width={[`150px`, null, `187px`]}
        height={[`40px`, null, `50px`]}
      />
    </Clink>
  </Link>
);

export default StoreLinkAlt;
